const actionType = {
    USER_LOGIN_LOADING : "USER_LOGIN_LOADING",
    USER_LOGIN_SUCCESS : "USER_LOGIN_SUCCESS",
    USER_LOGIN_ERROR : "USER_LOGIN_ERROR",
    USER_SET_TOKEN : "USER_SET_TOKEN",
    USER_INFO : "USER_INFO",
    JUN_INFO : "JUN_INFO",
    TOP_LATEST_BLOG : "TOP_LATEST_BLOG",
    TOP_FIVE_LATEST_BLOG : "TOP_FIVE_LATEST_BLOG",
    TOP_FOUR_NEWS_BLOG : "TOP_FOUR_NEWS_BLOG",
    TOP_FOUR_BUSINESS_BLOG : "TOP_FOUR_BUSINESS_BLOG",
    TOP_FOUR_SOCIOLOGY_BLOG : "TOP_FOUR_SOCIOLOGY_BLOG",
    TOP_FOUR_TECH_BLOG : "TOP_FOUR_TECH_BLOG",
    TOP_FOUR_ECONOMIC_BLOG : "TOP_FOUR_ECONOMIC_BLOG",
    TOP_FOUR_OTHER_BLOG : "TOP_FOUR_OTHER_BLOG",
    LATEST_BLOGS_OF_PAGE : "LATEST_BLOGS_OF_PAGE",
    LATEST_BLOGS_OF_WEB : "LATEST_BLOGS_OF_WEB",
    SET_LOADER : "SET_LOADER",
    SINGLE_BLOG_DATA : "SINGLE_BLOG_DATA",
    SHARE_LINK : "SHARE_LINK"
}


export default actionType